import { render } from "./FilePreviewModal.vue?vue&type=template&id=34059cda&scoped=true"
import script from "./FilePreviewModal.vue?vue&type=script&lang=js"
export * from "./FilePreviewModal.vue?vue&type=script&lang=js"

import "./FilePreviewModal.vue?vue&type=style&index=0&id=34059cda&scoped=true&lang=css"

import exportComponent from "/Users/jaimevalencia/Documents/PROYECTOS/SERVIDOR_GIT/soporte_bis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34059cda"]])

export default __exports__